<template>
  <div class="login-box">
    <div class="title">
      <img src="@/assets/jetlympic/logo2.png" />
    </div>
    <div class="switch">
      <div @click="type = 'mobile'" :class="{ active: type === 'mobile' }">+86手机号登录</div>
      <div @click="type = 'email'" :class="{ active: type === 'email' }">邮箱登录(OverSea)</div>
    </div>
    <div v-if="type === 'mobile'">
      <div class="form">
        <div class="item">
          <div class="region">+86</div><input type="number" v-model="mobile" placeholder="请输入手机号" />
        </div>
        <div class="item">
          <input type="number" v-model="code" placeholder="请输入验证码" />
          <div class="vali-btn" @click.stop.prevent="getCode">{{valiBtn}}</div>
        </div>
      </div>
      <div class="prompt">If you do not have a +86 phone number, please log in with your email.</div>
      <div class="btn" @click="onSubmit">登录</div>
    </div>
    <div v-if="type === 'email'">
      <div class="form">
        <div class="item">
          <input type="text" v-model="email" placeholder="Enter your email address" />
        </div>
        <div class="item">
          <input type="number" v-model="emailCode" placeholder="Enter verification code" />
          <div class="vali-btn" @click.stop.prevent="getEmailCode">{{emailValiBtn}}</div>
        </div>
      </div>
      <div class="btn" @click="onEmailSubmit">Login</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {Field, Form, Toast, Image as VanImage, Icon, CellGroup, Popup, Cell, Checkbox } from 'vant'
import { getCode, getProfile, loginByMobile,getEmailCode,fastBindByEmail } from "@/api/user";
import {setToken} from "@/libs/cookie-storage";
import { S365Util } from '@/utils/s365Util'
import {QNImageUtil,RegExpr} from "@/utils";
Vue.use(Field).use(Form).use(VanImage).use(Icon).use(CellGroup).use(Popup).use(Cell).use(Checkbox)

export default {
  data() {
    return {
      region: '+86',
      logo: '',
      redirect: '',
      mobile: '',
      code: '',
      emailCode: '',
      email: '',
      valiBtn: '获取验证码',
      emailValiBtn: 'Get Code',
      disabled: false,
      popupVisible: false,
      countryCodes: [
        { name: '中国大陆 (+86)', code: '+86' },
        { name: '中国台湾 (+886)', code: '+886' },
      ],
      checked: false,
      type: 'mobile'
    }
  },
  mounted() {
    this.redirect = this.$route.query.redirect
    if (S365Util.isInApp()) {
      this.logo = QNImageUtil.originView('FhVneyw0pMrHZgYR4oT1cPo7_8es')
    } else {
      this.logo = QNImageUtil.originView('FmrRsONDG8NJKfhs7dQ-Z348JMm0')
    }
  },
  methods: {
    goPrivacy() {
      window.open('https://www.snsports.cn/m/bmb-privacy.html')
    },
    goAgreement() {
      window.open('http://www.snsports.cn/m/tos.html')
    },
    onSubmit() {
      const params = {}
      if (this.region === '+886') {
        params.loginName = '886-' + this.mobile
      } else {
        params.loginName = this.mobile
      }
      params.sendCode = this.code
      params.type = 'mobile'
      params.action = 'fastBind'
      loginByMobile(params).then(res => {
        const { data } = res
        getProfile({ passport: data.session.id })
        setToken(data.session.id)
        // getProfile({ passport: data.session.id })
        window.localStorage.setItem('bm-match-h5-user', JSON.stringify(data.user))
        Toast('登录成功')
        this.$router.replace({ path: decodeURIComponent(this.redirect) })
      })
    },
    onEmailSubmit() {
      const params = {
        email: this.email,
        sendCode: this.emailCode
      }
      fastBindByEmail(params).then(res => { 
        const { data } = res
        getProfile({ passport: data.session.id })
        setToken(data.session.id)
        // getProfile({ passport: data.session.id })
        window.localStorage.setItem('bm-match-h5-user', JSON.stringify(data.user))
        Toast('登录成功')
        this.$router.replace({ path: decodeURIComponent(this.redirect) })
      })
    },
    getCode() {
      if (this.disabled) {
        return
      }
      let params = {}
      if (!this.mobile) {
        Toast('请先输入手机号')
        return
      }
      if (!RegExpr.checkMobile(this.mobile)) {
        Toast('请输入正确的手机号')
        return
      }
      params = {
        loginType: 'mobile',
        action: 'sendFastBindCode'
      }
      if (this.region === '+886') {
        params.mobile = '886-' + this.mobile
      } else {
        params.mobile = this.mobile
      }
      this.tackBtn()
      getCode(params).then(() => {})
    },
    getEmailCode() {
      if (this.disabled) {
        return
      }
      let params = {}
      if (!this.email) {
        Toast('请先输入邮箱')
        return
      }
      if (!RegExpr.isEmail(this.email)) {
        Toast('请输入正确的邮箱')
        return
      }
      params = {
        email: this.email
      }
      this.tackEmailBtn()
      getEmailCode(params).then(() => {})
    },
    tackBtn() {
      let time = 60
      this.valiBtn = '60秒后重试'
      this.disabled = true
      const timer = setInterval(() => {
        if (time === 0) {
          clearInterval(timer)
          this.valiBtn = '获取验证码'
          this.disabled = false
        } else {
          this.disabled = true
          this.valiBtn = time + '秒后重试'
          time--
        }
      }, 1000)
    },
    tackEmailBtn() {
      let time = 60
      this.emailValiBtn = '60S GET CODE'
      this.disabled = true
      const timer = setInterval(() => {
        if (time === 0) {
          clearInterval(timer)
          this.emailValiBtn = 'Get Code'
          this.disabled = false
        } else {
          this.disabled = true
          this.emailValiBtn = time + 'S GET CODE'
          time--
        }
      }, 1000)
    },
    showPopup() {
      this.popupVisible = true;
    },
    selectCountryCode(code) {
      this.region = code // 在选择国家代码后自动在输入框中添加空格
      this.popupVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.login-box{
  width: 100vw;
  height: 100vh;
  background-color: #F5F5F5;
  padding: 0 28px;
  box-sizing: border-box;
  .title{
    padding-top: 18px;
    text-align: center;

    img{
      width: 288px;
    }
  }
  .switch{
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 18px;
    font-size: 16px;
    color: #73767A;
    .active{
      color: #3D3D3D;
      font-weight: 800;
    }
  }
  .form{
    margin-top: 30px;
    .item{
      width: 319px;
      height: 42px;
      border-radius: 3px;
      background-color: #fff;
      display: flex;
      align-items: center;
      // padding-left: 10px;
      box-sizing: border-box;
      margin-bottom: 10px;
      overflow: hidden;
      .region{
        height: 100%;
        line-height: 42px;
        color: #73767A;
        margin-right: 12px;
        width: 60px;
        text-align: center;
        background-color: #E9E9EB;
      }
      input{
        flex: 1;
        width: 100%;
        height: 100%;
        background-color: transparent;
        border: none;
        padding-left: 10px;
      }
      .vali-btn{
        background: #fff;
        width: 105px;
        height: 42px;
        border-radius: 0px 3px 3px 0px;
        font-size: 14px;
        font-weight: 500;
        color: #fff;
        text-align: center;
        line-height: 42px;
        background-color: #00A7FF;
      }
    }
  }
  .prompt{
    font-size: 12px;
    font-weight: 500;
    color: #B1B3B8;
  }
  .btn{
    width: 317px;
    height: 44px;
    border-radius: 22px;
    background: #00A7FF;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    text-align: center;
    line-height: 44px;
    margin: 0 auto;
    margin-top: 26px;
  }
  .agreement{
    display: flex;
    align-items: flex-start;
    font-size: 12px;
    font-weight: 500;
    margin-top: 20px;
    .checkbox{
      width: 40px;
      padding-top: 2px;
    }
    span{
      color: #74A3CC;
    }
    .text{
      // padding-left: 22px;
      color: #909399;
    }
  }
}
.mc-auth-login {
  .my-field {
    ::v-deep .van-field__body {
      display: flex;
      flex-flow: row-reverse;
    }
  }
}
</style>
